<template>
  <div>
    <el-row :gutter="5">
      <el-col :span="7" :xs="24">
        <el-date-picker
          v-model="time"
          :clearable="false"
          :picker-options="pickerOptions"
          end-placeholder="结束月份"
          range-separator="至"
          start-placeholder="开始月份"
          type="monthrange"
        />
      </el-col>
      <el-col :span="2" :xs="12" class="xs-mp-10">
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
      <el-col :span="2" :xs="12" class="xs-mp-10">
        <el-button plain type="success" @click="reset">重置</el-button>
      </el-col>
    </el-row>
    <div style="display: flex; justify-content: flex-end; padding: 5px">
      <el-button
        type="primary"
        icon="el-icon-upload2"
        @click="handleExportTableBtnClick"
        >导出</el-button
      >
    </div>

    <el-table id="exportTab2" :data="records" class="m-mp-10" stripe>
      <el-table-column label="日期" prop="month" />
      <el-table-column align="center" label="我的分润">
        <el-table-column label="余额分润" prop="agentBalanceDividend" />
        <el-table-column label="豆币分润" prop="agentTokenDividend" />
      </el-table-column>

      <el-table-column align="center" label="总支出">
        <el-table-column label="余额支出" prop="balanceDisburse" />
        <el-table-column label="豆币支出" prop="tokenDisburse" />
      </el-table-column>

      <el-table-column align="center" label="总营收">
        <el-table-column label="余额营收" prop="balanceExpenditure" />
        <el-table-column label="豆币营收" prop="tokenExpenditure" />
      </el-table-column>

      <el-table-column align="center" label="包月">
        <el-table-column label="充电包月" prop="monthlyBalanceIncome" />
        <el-table-column label="代开充电" prop="monthlyTokenIncome" />
        <el-table-column label="停车包月" prop="carportMonthlyBalanceIncome" />
        <el-table-column label="代开停车" prop="carportMonthlyTokenIncome" />
      </el-table-column>

      <el-table-column align="center" label="临时">
        <el-table-column label="充电消费" prop="weChatExpenditure" />
        <el-table-column label="停车消费" prop="weChatParkingExpenditure" />
        <el-table-column label="刷卡消费" prop="cardExpenditure" />
        <el-table-column label="刷卡停车" prop="cardParkingExpenditure" />
      </el-table-column>

      <el-table-column label="后台代充" prop="cardTokenRecharge" />
      <el-table-column label="电度" prop="power" />
    </el-table>

    <!-- <el-table id="exportTab2" :data="records" class="m-mp-10" stripe>
      <el-table-column label="日期" prop="month" />
      <el-table-column align="center" label="营收统计">
        <el-table-column label="我的分润">
          <template #default="scope">
            {{ scope.row.agentDividend | numFilter }}
          </template>
        </el-table-column>
        <el-table-column label="代币分润" prop="agentTokenDividend">
          <template #default="scope">
            {{ scope.row.agentTokenDividend | numFilter }}
          </template>
        </el-table-column>
        <el-table-column label="支出">
          <template #default="scope">
            {{ scope.row.disburse | numFilter }}
          </template>
          <template slot="header">
            <el-popover
              content="该项数值表示您账户的支出总额,包括漫游充电
                                            带来的漫游支出,账号提现,扣除提现手续费等"
              placement="bottom"
              trigger="hover"
              width="200"
            >
              <span slot="reference"
                >支出<i class="el-icon-warning" style="color: #e6a23c" />
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="总营收">
          <template #default="scope">
            {{
              (info.hasApp == "0"
                ? scope.row.dailyMonthlyIncome +
                  scope.row.dailyCarportMonthlyIncome +
                  scope.row.parkingExpenditure
                : scope.row.totalIncome) | numFilter
            }}
          </template>
          <template slot="header">
            <el-popover
              content="拥有自己的公众号:充值总和
                                         没有自己的公众号:分润总和"
              placement="bottom"
              trigger="hover"
              width="220"
            >
              <span slot="reference"
                >总营收<i class="el-icon-warning" style="color: #e6a23c" />
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="充电包月" prop="monthlyIncome" />
        <el-table-column label="停车包月" prop="carPortMonthlyIncome" />
        <el-table-column label="个人提现" prop="agentWithdraw" />
        <el-table-column label="电度" prop="power" />
      </el-table-column>
      <el-table-column align="center" label="扫码收入">
        <el-table-column prop="weChatRecharge">
          <template slot="header">
            <el-popover
              content="该数值表示您名下所有用户在线充值的总额
                                         包括电卡在线充值的金额,但不包括通过商户平台
                                           给电卡充值的金额
                                           注意:存在少量新用户充值后未首次充电,该部分
                                            充值金额因用户尚未绑定电站,所以无法统计在内,
                                            实际充值金额请以[交易中心]-[充值消费]中实时查询结果为准"
              placement="bottom"
              trigger="hover"
              width="220"
            >
              <span slot="reference"
                >充值<i class="el-icon-warning" style="color: #e6a23c" />
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="weChatExpenditure">
          <template slot="header">
            <el-popover
              content="该项数值表示您名下所有的微信,支付包,app用户的充电消费总额
                                        ,包括在其他运营商的设备上充电所产生的漫游消费总额"
              placement="bottom"
              trigger="hover"
              width="200"
            >
              <span slot="reference"
                >充电消费<i class="el-icon-warning" style="color: #e6a23c"
              /></span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="parkingExpenditure">
          <template slot="header">
            <el-popover
              content="该项数值表示您名下所有的微信,支付包,app用户的停车消费总额"
              placement="bottom"
              trigger="hover"
              width="200"
            >
              <span slot="reference"
                >停车消费<i class="el-icon-warning" style="color: #e6a23c"
              /></span>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="刷卡收入">
        <el-table-column label="充值" prop="cardRecharge">
          <template slot="header">
            <el-popover
              content="该项数值表示您名下所有的电卡用户通过商户平台
                                             充值的总金额,不包括电卡用户在线充值的金额"
              placement="bottom"
              trigger="hover"
            >
              <span slot="reference"
                >充值<i class="el-icon-warning" style="color: #e6a23c" />
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="消费" prop="cardExpenditure">
          <template slot="header">
            <el-popover
              content="该项数值表示您名下的所有电卡用户的充电消费总额,
                                        因电卡不支持漫游充电,所以该数值不包含漫游"
              placement="bottom"
              trigger="hover"
              width="200"
            >
              <span slot="reference"
                >消费<i class="el-icon-warning" style="color: #e6a23c" />
              </span>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table> -->
  </div>
</template>

<script>
import agentGetMonthlyReport from "@/api/fund/order-manage/agentGetMonthlyReport";
import createdMixin from "@/mixin/createMixin";
import numberFilters from "@/mixin/numberFilters";
import timeMixin from "@/mixin/timeMixin";
import { exportTableToExcel } from "@/utils/exportTable";
import { monthTime } from "@/utils/time";
import { mapGetters } from "vuex";

export default {
  name: "RevenueChartTwo",
  mixins: [createdMixin, timeMixin, numberFilters],
  data() {
    return {
      time: [],
      pickerOptions: {
        onPick: (pick) => {
          this.pickDate = pick;
        },
        disabledDate: (time) => {
          // const currDate = new Date();
          // if (time.getMonth() >= currDate.getMonth()) return true;
          // const { minDate, maxDate } = this.pickDate;
          // if (minDate && !maxDate) {
          //   const diff = Math.abs(minDate.valueOf() - time.valueOf());
          //   if (diff > 1000 * 3600 * 24 * 365) {
          //     return true;
          //   }
          // }

          const now = new Date();
          const currentMonth =
            new Date(now.getFullYear(), now.getMonth(), 1) - 1;
          const t = new Date(time.getFullYear(), time.getMonth(), 1);

          // 1️⃣ 未来月份禁用
          if (t > currentMonth) return true;

          const { minDate, maxDate } = this.pickDate;

          // 2️⃣ 已经选了开始月 → 动态限制 ±12个月
          if (minDate && !maxDate) {
            const start = new Date(
              minDate.getFullYear(),
              minDate.getMonth(),
              1
            );

            const minLimit = new Date(
              start.getFullYear(),
              start.getMonth() - 11,
              1
            );
            const maxLimit = new Date(
              start.getFullYear(),
              start.getMonth() + 11,
              1
            );

            return t < minLimit || t > maxLimit;
          }

          return false;
        },
      },
      pickDate: "",
      records: [],
      params: {
        startYM: monthTime("start-prev"),
        endYM: monthTime("end-prev"),
      },
    };
  },
  computed: {
    ...mapGetters(["info"]),
  },
  mounted() {
    this.initDate();
  },
  methods: {
    handleExportTableBtnClick() {
      exportTableToExcel("exportTab2", [], "营收报表(月报).xlsx", true);
    },
    initDate() {
      console.log(this.params);
      let dates = [new Date(this.params.startYM), new Date(this.params.endYM)];
      this.time = dates;
    },
    search() {
      if (this.time.length === 2) {
        this.params.startYM = monthTime(this.time[0] / 1000);
        this.params.endYM = monthTime(this.time[1] / 1000);
        this.fetchData();
      } else {
        this.$message.error("请先选择日期");
      }
    },
    reset() {
      this.params.startYM = monthTime("start-prev");
      this.params.endYM = monthTime("end-prev");
      this.initDate();
      this.fetchData();
    },
    fetchData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      agentGetMonthlyReport(this.params)
        .then((res) => {
          this.records = res.data;
          if (res.code != 1) {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>
